<div class="go-paperless main">
  <ds-error-message [errorList]="errorList"></ds-error-message>
  <div class="row">
    <div class="column twelve">
      <h2 class="heading-sub-page">Sign Up for Paperless Policy Documents</h2>
    </div>
    <div class="column twelve">
      @if (!(requiresSignature | async)) {
        <p>
          It's quick and easy to enroll. Just confirm your email address and accept the Terms and
          Conditions below.
        </p>
      }
      @if (requiresSignature | async) {
        <p>
          To sign up for paperless policy documents, please verify your email address and accept the
          Terms and Conditions below. You’ll then be asked to review a consent form and provide an
          electronic signature. If you decide later you’d prefer paper documents, just return to the
          Policies section of My Account to change your delivery preference.
        </p>
      }
      <p class="pad-top-20 pad-bottom-40">
        <strong>NOTE:</strong> Paperless documents aren't yet available for Life or Commercial
        policies at this time.
      </p>
    </div>
  </div>
  <hr aria-hidden="true" class="dashed" />
  <form [formGroup]="enrollPaperlessForm" (ngSubmit)="enroll()">
    <div class="row">
      <p class="note pad-bottom-20">
        We'll send your policy document notifications to
        <strong>{{ getMyAccountEmailAddress() }}</strong
        >. Need to change this email address? You can update your contact info under
        <a dsRouterLink="/profile">Profile</a>.
      </p>
    </div>
    <div class="row">
      <h4 class="heading-sub-section">Terms &amp; Conditions:</h4>
      <fieldset class="pad-left-20">
        <span class="inline-block">
          <input
            authCheck
            [permissionName]="'paperlesspolicydocsTandC_accept'"
            [checkAction]="'disable'"
            class="checkbox"
            type="checkbox"
            id="agreeToTermsCheckbox"
            formControlName="agreeToTerms"
            required
          />
          <label
            class="checkbox-label"
            for="agreeToTermsCheckbox"
            data-cy="setPrefsEasyButtonTermsCheckboxLabel"
            ><p>
              I have read and agree to the
              <a href="/terms/go-paperless" target="_blank">Terms &amp; Conditions</a>
            </p></label
          >
        </span>
      </fieldset>
    </div>
    <div class="row callToAction">
      <span class="md-float-right">
        <a (click)="cancel()" class="pad-horizontal-20">Cancel</a>
        <button
          ds-button
          type="submit"
          [disabled]="
            enrollPaperlessForm.invalid ||
            !(roleService.isAuthorized('enrollpaperlesspolicydocs_submit') | async) ||
            disableEnrollBtn
          "
          data-cy="goPaperlessSignUpBtn"
        >
          Sign Up
        </button>
      </span>
    </div>
  </form>
</div>
